export interface IOOEUserState {
  ErrorFlag: string | undefined;
  ErrorMessage: undefined;
  OpenOrder: IOOEOrder | undefined;
  jdeVehicleID: string | undefined;
  quickSaveYN: 'Y' | 'N';
  showCodes: any[];
  showroomViewYN: 'Y' | 'N';
  tempVehicleYN: 'N' | 'Y';
  genericVehicleYN?: 'N' | 'Y';
  hideBuyPriceTF?: boolean;
  externalUsersUsualCustomerNumber?: string | undefined;
  defaultShipTo: number | undefined;
  genericQuotesOnlyTF: boolean;
  customPricingFunction: string | undefined;
  validOrderTypes?: string[];
}

export interface IOOEOrder {
  orderNumber: string | undefined;
  customerNumber: number | undefined;
  orderReference: string | undefined;
  customerName: string | undefined;
  orderValue: number;
  partsVehicleID: number;
  customerVehicleID: string;
  vehicleDescription: string | undefined;
  readOnlyEPCTF: boolean;
  orderType: string;
  orderCompany: string;
  pendingPaymentsTF: boolean;
  pendingLineChangeTF: boolean;
  orderClass?: string | undefined;
}

export interface IOOEOrderHeader {
  branch: string;
  brand: string;
  customerName: string;
  customerNumber: number;
  customerVehicleID: number;
  orderCompany: string;
  orderCreateDateTime: Date;
  orderNote: string;
  orderNoteCustFacing: string;
  orderNumber: string;
  orderType: string;
  partsVehicleID: number;
  reference: string;
  requestDate: Date;
  shipToNumber: number;
  userEmail: string;
  vehicleDescription: string;
}

export interface IOOESelectedVehicle {
  partsVehicleID: string;
  customerVehicleID: string | number;
  vehicleDescription: string | undefined;
}

export class OOEUserState implements IOOEUserState {
  ErrorFlag: string | undefined;
  ErrorMessage: undefined;
  OpenOrder: IOOEOrder | undefined;
  jdeVehicleID: string | undefined;
  quickSaveYN: 'Y' | 'N';
  showCodes: any[];
  showroomViewYN: 'Y' | 'N';
  tempVehicleYN: 'Y' | 'N';
  defaultShipTo: number | undefined;
  externalUsersUsualCustomerNumber?: string | undefined;
  genericQuotesOnlyTF: boolean;
  customPricingFunction: string | undefined;
}

export class SelectedVehicle implements IOOESelectedVehicle {
  partsVehicleID: string;
  customerVehicleID: string | number;
  vehicleDescription: string | undefined;
  jdeVehicleID: string;
}

export interface IOOEUserType {
  ErrorFlag: string | undefined;
  ErrorMessage: undefined;
  userType: string | undefined;
}

export interface ApiResponse {
  [k: string]: any;
  ErrorFlag: string;
  ErrorMessage: string;
}

